import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export async function requestHotel(data) {
  var result = {return: 0,msg: 'Something went wrong submitting hotel!',data: {}}

  let token = store.getState().user.userData.accessToken;

  // console.log(" --- on Single Booking Data ---")
  // console.log("data - ",data)
  // console.log(" --------- -----------")

  let headers = {
    Authorization: `Bearer ${token}`,
  }


  await fetchServer({method: "PATCH",url: path.api+'/hotels/request-hotel/',data,
    headers
  })
  .then((res) => {
    console.log(" => ",res)
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res?.error?.message) result['msg'] = res?.error?.message;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
  })

  return result;

}